import { changePasswordActionsStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordActions";
import { css } from "styled-components";

changePasswordActionsStyles.saveButton = {
    css: css`
        width: 100%;
        span {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            text-transform: uppercase;
        }
    `,
}

changePasswordActionsStyles.cancelButton = {
    mergeCss:true,
    css: css`
        width: 100%;
    `,
}